import React from 'react';
import { useSelector } from 'react-redux';

const PricesComponent = ({
  className = '',
  children
}) => {
  const { retailer } = useSelector((reduxState) => reduxState.retailerReducer);

  if (retailer.hide_product_prices === true) return null;

  return (
    <div className={`${className}`}>
      {children}
    </div>
  );
};

export default PricesComponent;
